import $http from '../../utils/http';
// 旅游资源管理
let appointment = '/tio/touriIndustryManage';

// 资源概况数量统计与分布分析
const getSituation = params => {
    return $http({
      url: appointment + '/tim/resourceSituation/api/getSituation',
      params
    });
  }

// 资源概况数区域划分下拉列表
const getRegions = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getRegions',
    params
  });
}

// 占比分析资源等级
const getDirectoriesScoreLevelPercentage = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesScoreLevelPercentage',
    params
  });
}

// 占比分类编码类别
const getDirectoriesCodingClassifyPercentage = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesCodingClassifyPercentage',
    params
  });
}

// 占比分析行政区域下拉列表
const getPercentageRegions = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getPercentageRegions',
    params
  });
}

// 景观下拉列表
const getPercentageClassify = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getPercentageClassify',
    params
  });
}

// 资源名录区域列表
const getDirectoriesRegions = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesRegions',
    params
  });
}

// 资源名录列表
const getDirectories = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectories',
    params
  });
}

// 资源名录列表分类编码下拉
const getDirectoriesCodingClassify = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesCodingClassify',
    params
  });
}

// 资源名录详情
const getDirectoriesInfo = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesInfo',
    params
  });
}

// 地图列表
const getDirectoriesPositions = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesPositions',
    params
  });
}

// 地图列表等级枚举
const getDirectoriesLevels = params => {
  return $http({
    url: appointment + '/tim/resourceSituation/api/getDirectoriesLevels',
    params
  });
}

export default {
    getSituation,
    getRegions,
    getDirectoriesScoreLevelPercentage,
    getDirectoriesCodingClassify,
    getDirectoriesCodingClassifyPercentage,
    getPercentageRegions,
    getPercentageClassify,
    getDirectories,
    getDirectoriesInfo,
    getDirectoriesRegions,
    getDirectoriesPositions,
    getDirectoriesLevels
}